export const overrideFieldIds = (fields, newFieldIdsByTarget)=>{
    return fields.map((field)=>({
            ...field,
            id: 'target' in field ? newFieldIdsByTarget[field.target] : field.id
        }));
};

//# sourceMappingURL=field-id-overrides.js.map